import { PageMessage } from "./PageMessage";
export default PageMessage;
export * from "./PageMessage";
